export default {
  instructions: `
    Play the video to learn how to record your voice in the next step.
  `,
  done: `
    Click the <b>Continue</b> button when you are done watching.
  `,
};
